import React from 'react'

const Gharara = () => {
  return (
    <div>Gharara</div>
  )
}

export default Gharara